import gql from "graphql-tag"
import fullBasket from "./fullBasket"

const partialCheckoutRedemption = gql`
  fragment partialCheckoutRedemption on CheckoutRedemption {
    dateUnix
    isUsed
    uuid
    type
    metadata {
      createdAt
    }
    dealSnapshot {
      uuid
      type
      bannerImage
      description
      header
      importantInfo
      cardImage
      internalIdentifier
      location {
        city
      }
      redemptionInstructions
      termsAndConditions
      thumbnailImage
      typeHighlight
      savings {
        userSavings {
          header
          type
          value
        }
      }
      externalLinks {
        web
      }
    }
    order {
      uuid
      paymentId
      totals {
        total {
          value
          currency
        }
        totalBeforeDiscount {
          value
          currency
        }
        totalVAT {
          value
          currency
        }
      }
      products {
        product {
          uuid
          name
        }
        items {
          uuid
          code
          expiry
          pin
          status
          type
        }
      }
      basket {
        ...fullBasket
      }
    }
  }

  ${fullBasket}
`

export default partialCheckoutRedemption
